/** accounts actions */
export const FETCHING_ACCOUNTS_REQUEST = "FETCHING_ACCOUNTS_REQUEST";
export const FETCHING_ACCOUNTS_SUCCEEDED = "FETCHING_ACCOUNTS_SUCCEEDED";
export const FETCHING_ACCOUNTS_FAILED = "FETCHING_ACCOUNTS_FAILED";

/** account management actions */
export const FETCHING_ACCOUNT = "FETCHING_ACCOUNT";
export const FETCHING_ACCOUNT_SUCCEEDED = "FETCHING_ACCOUNT_SUCCEEDED";
export const FETCHING_ACCOUNT_FAILED = "FETCHING_ACCOUNTS_FAILED";

export const UPDATING_ACCOUNT = "UPDATING_ACCOUNT";
export const UPDATING_ACCOUNT_SUCCEEDED = "UPDATING_ACCOUNT_SUCCEEDED";
export const UPDATING_ACCOUNT_FAILED = "UPDATING_ACCOUNT_FAILED";

export const UPDATING_ACCOUNT_SUBSCRIPTION = "UPDATING_ACCOUNT_SUBSCRIPTION";
export const UPDATING_ACCOUNT_SUBSCRIPTION_SUCCEEDED =
  "UPDATING_ACCOUNT_SUBSCRIPTION_SUCCEEDED";
export const UPDATING_ACCOUNT_SUBSCRIPTION_FAILED =
  "UPDATING_ACCOUNT_SUBSCRIPTION_FAILED";

export const UPDATING_ACCOUNT_TRAIL = "UPDATING_ACCOUNT_TRAIL";
export const UPDATING_ACCOUNT_TRAIL_SUCCEEDED =
  "UPDATING_ACCOUNT_TRAIL_SUCCEEDED";
export const UPDATING_ACCOUNT_TRAIL_FAILED = "UPDATING_ACCOUNT_TRAIL_FAILED";

export const UPDATING_ACCOUNT_SETTINGS = "UPDATING_ACCOUNT_SETTINGS";
export const UPDATING_ACCOUNT_SETTINGS_SUCCEEDED =
  "UPDATING_ACCOUNT_SETTINGS_SUCCEEDED";
export const UPDATING_ACCOUNT_SETTINGS_FAILED =
  "UPDATING_ACCOUNT_SETTINGS_FAILED";

export const UPDATING_SSO_CONFIGURATION = "UPDATING_SSO_CONFIGURATION";
export const UPDATING_SSO_CONFIGURATION_SUCCEEDED =
  "UPDATING_SSO_CONFIGURATION_SUCCEEDED";
export const UPDATING_SSO_CONFIGURATION_FAILED =
  "UPDATING_SSO_CONFIGURATION_FAILED";

export const UPDATING_ACCOUNT_INVITATION = "UPDATING_ACCOUNT_INVITATION";
export const UPDATING_ACCOUNT_INVITATION_FAILED = "UPDATING_ACCOUNT_INVITATION_FAILED"; 
export const UPDATING_ACCOUNT_INVITATION_SUCCEEDED = "UPDATING_ACCOUNT_INVITATION_SUCCEEDED"; 


export const DELETING_ACCOUNT_REQUEST = "DELETING_ACCOUNT_REQUEST";
export const DELETING_ACCOUNT_SUCCEEDED = "DELETING_ACCOUNT_SUCCEEDED";
export const DELETING_ACCOUNT_FAILED = "DELETING_ACCOUNT_FAILED";

export const FETCHING_USERS_COUNT = "FETCHING_USERS_COUNT";
export const FETCHING_USERS_COUNT_SUCCEEDED = "FETCHING_USERS_COUNT_SUCCEEDED";
export const FETCHING_USERS_COUNT_FAILED = "FETCHING_USERS_COUNT_FAILED";

export const FETCHING_ACTIVE_USERS_COUNT = "FETCHING_ACTIVE_USERS_COUNT";
export const FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED =
  "FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED";
export const FETCHING_ACTIVE_USERS_COUNT_FAILED =
  "FETCHING_ACTIVE_USERS_COUNT_FAILED";

export const FETCHING_DEACTIVATED_USERS_COUNT =
  "FETCHING_DEACTIVATED_USERS_COUNT";
export const FETCHING_DEACTIVATED_USERS_COUNT_SUCCEEDED =
  "FETCHING_DEACTIVATED_USERS_COUNT_SUCCEEDED";
export const FETCHING_DEACTIVATED_USERS_COUNT_FAILED =
  "FETCHING_DEACTIVATED_USERS_COUNT_FAILED";

export const FETCHING_DAU_COUNT = "FETCHING_DAU_COUNT";
export const FETCHING_DAU_COUNT_SUCCEEDED = "FETCHING_DAU_COUNT_SUCCEEDED";
export const FETCHING_DAU_COUNT_FAILED = "FETCHING_DAU_COUNT_FAILED";

export const FETCHING_WAU_COUNT = "FETCHING_WAU_COUNT";
export const FETCHING_WAU_COUNT_SUCCEEDED = "FETCHING_WAU_COUNT_SUCCEEDED";
export const FETCHING_WAU_COUNT_FAILED = "FETCHING_WAU_COUNT_FAILED";

export const FETCHING_MAU_COUNT = "FETCHING_MAU_COUNT";
export const FETCHING_MAU_COUNT_SUCCEEDED = "FETCHING_MAU_COUNT_SUCCEEDED";
export const FETCHING_MAU_COUNT_FAILED = "FETCHING_MAU_COUNT_FAILED";

export const FETCHING_NEW_USERS_COUNT = "FETCHING_NEW_USERS_COUNT";
export const FETCHING_NEW_USERS_COUNT_SUCCEEDED =
  "FETCHING_NEW_USERS_COUNT_SUCCEEDED";
export const FETCHING_NEW_USERS_COUNT_FAILED =
  "FETCHING_NEW_USERS_COUNT_FAILED";

export const FETCHING_COLLECTIONS_COUNT = "FETCHING_COLLECTIONS_COUNT";
export const FETCHING_COLLECTIONS_COUNT_SUCCEEDED =
  "FETCHING_COLLECTIONS_COUNT_SUCCEEDED";
export const FETCHING_COLLECTIONS_COUNT_FAILED =
  "FETCHING_COLLECTIONS_COUNT_FAILED";

/** assets actions */
export const FETCHING_ASSETS = "FETCHING_ASSETS";
export const FETCHING_ASSETS_SUCCEEDED = "FETCHING_ASSETS_SUCCEEDED";
export const FETCHING_ASSETS_FAILED = "FETCHING_ASSETS_FAILED";

export const FETCHING_ASSETS_COUNT = "FETCHING_ASSETS_COUNT";
export const FETCHING_ASSETS_COUNT_SUCCEEDED =
  "FETCHING_ASSETS_COUNT_SUCCEEDED";
export const FETCHING_ASSETS_COUNT_FAILED = "FETCHING_ASSETS_COUNT_FAILED";

/** shares actions */
export const FETCHING_SHARES_COUNT = "FETCHING_SHARES_COUNT";
export const FETCHING_SHARES_COUNT_SUCCEEDED =
  "FETCHING_SHARES_COUNT_SUCCEEDED";
export const FETCHING_SHARES_COUNT_FAILED = "FETCHING_SHARES_COUNT_FAILED";

/** cognito user actions */
export const FETCHING_COGNITO_USER_PROFILE = "FETCHING_COGNITO_USER_PROFILE";
export const FETCHING_COGNITO_USER_PROFILE_SUCCEEDED =
  "FETCHING_COGNITO_USER_PROFILE_SUCCEEDED";
export const FETCHING_COGNITO_USER_PROFILE_FAILED =
  "FETCHING_COGNITO_USER_PROFILE_FAILED";

export const FETCHING_COGNITO_ACCESS_TOKEN = "FETCHING_COGNITO_ACCESS_TOKEN";
export const FETCHING_COGNITO_ACCESS_TOKEN_SUCCEEDED =
  "FETCHING_COGNITO_ACCESS_TOKEN_SUCCEEDED";
export const FETCHING_COGNITO_ACCESS_TOKEN_FAILED =
  "FETCHING_COGNITO_ACCESS_TOKEN_FAILED";

export const LOGOUT_COGNITO_USER = "LOGOUT_COGNITO_USER";

/** user management actions */
export const CREATING_USER_REQUEST = "CREATING_USER_REQUEST";
export const CREATING_USER_REQUEST_SUCCEEDED =
  "CREATING_USER_REQUEST_SUCCEEDED";
export const CREATING_USER_REQUEST_FAILED = "CREATING_USER_REQUEST_FAILED";

export const FETCHING_USER = "FETCHING_USER";
export const FETCHING_USER_SUCCEEDED = "FETCHING_USER_SUCCEEDED";
export const FETCHING_USER_FAILED = "FETCHING_USER_FAILED";

export const FETCHING_USERS = "FETCHING_USERS";
export const FETCHING_USERS_SUCCEEDED = "FETCHING_USERS_SUCCEEDED";
export const FETCHING_USERS_FAILED = "FETCHING_USERS_FAILED";

export const UPDATING_USER_REQUEST = "UPDATING_USER_REQUEST";
export const UPDATING_USER_SUCCEEDED = "UPDATING_USER_SUCCEEDED";
export const UPDATING_USER_FAILED = "UPDATING_USER_FAILED";

export const UPDATING_USER_PERMISSIONS = "UPDATING_USER_PERMISSIONS";
export const UPDATING_USER_PERMISSIONS_SUCCEEDED = "UPDATING_USER_PERMISSIONS_SUCCEEDED";
export const UPDATING_USER_PERMISSIONS_FAILED = "UPDATING_USER_PERMISSIONS_FAILED";


export const ACTIVATING_USER_REQUEST = "ACTIVATING_USER_REQUEST";
export const ACTIVATING_USER_SUCCEEDED = "ACTIVATING_USER_SUCCEEDED";
export const ACTIVATING_USER_FAILED = "ACTIVATING_USER_FAILED";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCEEDED = "RESET_PASSWORD_SUCCEEDED";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_REQUEST_SUCCEEDED =
  "RESET_PASSWORD_REQUEST_SUCCEEDED";
export const RESET_PASSWORD_REQUEST_FAILED = "RESET_PASSWORD_REQUEST_FAILED";

export const RESET_PASSWORD_LINK = "RESET_PASSWORD_LINK";
export const RESET_PASSWORD_LINK_SUCCEEDED = "RESET_PASSWORD_LINK_SUCCEEDED";
export const RESET_PASSWORD_LINK_FAILED = "RESET_PASSWORD_LINK_FAILED";

export const DELETING_USER_REQUEST = "DELETING_USER_REQUEST";
export const DELETING_USER_SUCCEEDED = "DELETING_USER_SUCCEEDED";
export const DELETING_USER_FAILED = "DELETING_USER_FAILED";

export const FETCHING_USER_GROUPS = "FETCHING_USER_GROUPS";
export const FETCHING_USER_GROUPS_SUCCEEDED = "FETCHING_USER_GROUPS_SUCCEEDED";
export const FETCHING_USER_GROUPS_FAILED = "FETCHING_USER_GROUPS_FAILED";

/** invitations actions */
export const FETCHING_INVITATION = "FETCHING_INVITATION";
export const FETCHING_INVITATION_SUCCEEDED = "FETCHING_INVITATION_SUCCEEDED";
export const FETCHING_INVITATION_FAILED = "FETCHING_INVITATION_FAILED";

export const FETCHING_INVITATIONS = "FETCHING_INVITATIONS";
export const FETCHING_INVITATIONS_SUCCEEDED = "FETCHING_INVITATIONS_SUCCEEDED";
export const FETCHING_INVITATIONS_FAILED = "FETCHING_INVITATIONS_FAILED";

export const FETCHING_INVITATIONS_COUNT = "FETCHING_INVITATIONS_COUNT";
export const FETCHING_INVITATIONS_COUNT_SUCCEEDED =
  "FETCHING_INVITATIONS_COUNT_SUCCEEDED";
export const FETCHING_INVITATIONS_COUNT_FAILED =
  "FETCHING_INVITATIONS_COUNT_FAILED";

export const RESENDING_INVITATION_REQUEST = "RESENDING_INVITATION_REQUEST";
export const RESENDING_INVITATION_SUCCEEDED = "RESENDING_INVITATION_SUCCEEDED";
export const RESENDING_INVITATION_FAILED = "RESENDING_INVITATION_FAILED";

export const DELETING_INVITATION_REQUEST = "DELETING_INVITATION_REQUEST";
export const DELETING_INVITATION_SUCCEEDED = "DELETING_INVITATION_SUCCEEDED";
export const DELETING_INVITATION_FAILED = "DELETING_INVITATION_FAILED";

export const FETCHING_STREAMS = "FETCHING_STREAMS";
export const FETCHING_STREAMS_SUCCEEDED = "FETCHING_STREAMS_SUCCEEDED";
export const FETCHING_STREAMS_FAILED = "FETCHING_STREAMS_FAILED";

export const DOWNLOAD_REPORT_REQUEST = "DOWNLOAD_REPORT_REQUEST";
export const DOWNLOADING_REPORT_SUCCEEDED = "DOWNLOADING_REPORT_SUCCEEDED";
export const DOWNLOADING_REPORT_FAILED = "DOWNLOADING_REPORT_FAILED";


/** IADB Actions */
export const CREATING_IADB_METADATA_REQUEST = "CREATING_IADB_METADATA_REQUEST";
export const CREATING_IADB_METADATA_REQUEST_SUCCEEDED = "CREATING_IADB_METADATA_REQUEST_SUCCEEDED";
export const CREATING_IADB_METADATA_REQUEST_FAILED = "CREATING_IADB_METADATA_REQUEST_FAILED";
export const FETCHING_IADB_METADATA_REQUEST = "FETCHING_IADB_METADATA_REQUEST";
export const FETCHING_IADB_METADATA_REQUEST_SUCCEEDED = "FETCHING_IADB_METADATA_REQUEST_SUCCEEDED";
export const FETCHING_IADB_METADATA_REQUEST_FAILED = "FETCHING_IADB_METADATA_REQUEST_FAILED";
export const FETCHING_IADB_METADATA_LIST_REQUEST_REQUEST = "FETCHING_IADB_METADATA_LIST_REQUEST_REQUEST";
export const FETCHING_IADB_METADATA_LIST_REQUEST_SUCCEEDED = "FETCHING_IADB_METADATA_LIST_REQUEST_SUCCEEDED";
export const FETCHING_IADB_METADATA_LIST_REQUEST_FAILED = "FETCHING_IADB_METADATA_LIST_REQUEST_FAILED";
export const FETCHING_IADB_METADATA_REQUEST_REQUEST_FAILED = "FETCHING_IADB_METADATA_LIST_REQUEST_FAILED";
export const UPDATING_IADB_METADATA_REQUEST = "UPDATING_IADB_METADATA_REQUEST";
export const UPDATING_IADB_METADATA_SUCCEEDED = "UPDATING_IADB_METADATA_SUCCEEDED"; 
export const UPDATING_IADB_METADATA_FAILED = "UPDATING_IADB_METADATA_FAILED";
export const DELETING_IADB_METADATA_REQUEST = "DELETING_IADB_METADATA_REQUEST";
export const DELETING_IADB_METADATA_SUCCEEDED = "DELETING_IADB_METADATA_SUCCEEDED";
export const DELETING_IADB_METADATA_FAILED = "DELETING_IADB_METADATA_FAILED";

/** cleverstory actions */
export const CREATING_CLEVERSTORY_WORKSPACE_REQUEST = "CREATING_CLEVERSTORY_WORKSPACE_REQUEST";
export const CREATING_CLEVERSTORY_WORKSPACE_SUCCEEDED = "CREATING_CLEVERSTORY_WORKSPACE_SUCCEEDED";
export const CREATING_CLEVERSTORY_WORKSPACE_FAILED = "CREATING_CLEVERSTORY_WORKSPACE_FAILED";

export const UPDATING_CLEVERSTORY_WORKSPACE_REQUEST = "UPDATING_CLEVERSTORY_WORKSPACE_REQUEST";
export const UPDATING_CLEVERSTORY_WORKSPACE_SUCCEEDED = "UPDATING_CLEVERSTORY_WORKSPACE_SUCCEEDED";
export const UPDATING_CLEVERSTORY_WORKSPACE_FAILED = "UPDATING_CLEVERSTORY_WORKSPACE_FAILED";

export const FETCHING_CLEVERSTORY_WORKSPACE = "FETCHING_CLEVERSTORY_WORKSPACE";
export const FETCHING_CLEVERSTORY_WORKSPACE_SUCCEEDED = "FETCHING_CLEVERSTORY_WORKSPACE_SUCCEEDED";
export const FETCHING_CLEVERSTORY_WORKSPACE_FAILED = "FETCHING_CLEVERSTORY_WORKSPACE_FAILED";

export const FETCHING_CLEVERSTORY_WORKSPACES = "FETCHING_CLEVERSTORY_WORKSPACES";
export const FETCHING_CLEVERSTORY_WORKSPACES_SUCCEEDED = "FETCHING_CLEVERSTORY_WORKSPACES_SUCCEEDED";
export const FETCHING_CLEVERSTORY_WORKSPACES_FAILED = "FETCHING_CLEVERSTORY_WORKSPACES_FAILED";


export const CREATING_CLEVERSTORY_DOMAIN_REQUEST = "CREATING_CLEVERSTORY_DOMAIN_REQUEST";
export const CREATING_CLEVERSTORY_DOMAIN_SUCCEEDED = "CREATING_CLEVERSTORY_DOMAIN_SUCCEEDED";
export const CREATING_CLEVERSTORY_DOMAIN_FAILED = "CREATING_CLEVERSTORY_DOMAIN_FAILED";

export const UPDATING_CLEVERSTORY_DOMAIN_REQUEST = "UPDATING_CLEVERSTORY_DOMAIN_REQUEST";
export const UPDATING_CLEVERSTORY_DOMAIN_SUCCEEDED = "UPDATING_CLEVERSTORY_DOMAIN_SUCCEEDED";
export const UPDATING_CLEVERSTORY_DOMAIN_FAILED = "UPDATING_CLEVERSTORY_DOMAIN_FAILED";

export const UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_REQUEST = "UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_REQUEST";
export const UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_SUCCEEDED = "UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_SUCCEEDED";
export const UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_FAILED = "UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_FAILED";

export const FETCHING_CLEVERSTORY_DOMAIN = "FETCHING_CLEVERSTORY_DOMAIN";
export const FETCHING_CLEVERSTORY_DOMAIN_SUCCEEDED = "FETCHING_CLEVERSTORY_DOMAIN_SUCCEEDED";
export const FETCHING_CLEVERSTORY_DOMAIN_FAILED = "FETCHING_CLEVERSTORY_DOMAIN_FAILED";

export const FETCHING_CLEVERSTORY_DOMAINS = "FETCHING_CLEVERSTORY_DOMAINS";
export const FETCHING_CLEVERSTORY_DOMAINS_SUCCEEDED = "FETCHING_CLEVERSTORY_DOMAINS_SUCCEEDED";
export const FETCHING_CLEVERSTORY_DOMAINS_FAILED = "FETCHING_CLEVERSTORY_DOMAINS_FAILED";

export const DELETING_CLEVERSTORY_DOMAIN_REQUEST = "DELETING_CLEVERSTORY_DOMAIN_REQUEST";
export const DELETING_CLEVERSTORY_DOMAIN_SUCCEEDED = "DELETING_CLEVERSTORY_DOMAIN_SUCCEEDED";
export const DELETING_CLEVERSTORY_DOMAIN_FAILED = "DELETING_CLEVERSTORY_DOMAIN_FAILED";

/** audit logs actions */
export const FETCHING_LOGS = "FETCHING_LOGS";
export const FETCHING_LOGS_SUCCEEDED = "FETCHING_LOGS_SUCCEEDED";
export const FETCHING_LOGS_FAILED = "FETCHING_LOGS_FAILED";

/** metrics actions */
export const FETCHING_METRICS = "FETCHING_METRICS";
export const FETCHING_METRICS_SUCCEEDED = "FETCHING_METRICS_SUCCEEDED";
export const FETCHING_METRICS_FAILED = "FETCHING_METRICS_FAILED";

export const FETCHING_USER_METRICS = "FETCHING_USER_METRICS";
export const FETCHING_USER_METRICS_SUCCEEDED = "FETCHING_USER_METRICS_SUCCEEDED";
export const FETCHING_USER_METRICS_FAILED = "FETCHING_USER_METRICS_FAILED";

// Adoption Metrics
export const FETCHING_ADOPTION_ACCOUNTS = "FETCHING_ADOPTION_ACCOUNTS";
export const FETCHING_ADOPTION_ACCOUNTS_SUCCEEDED = "FETCHING_ADOPTION_ACCOUNTS_SUCCEEDED";
export const FETCHING_ADOPTION_ACCOUNTS_FAILED = "FETCHING_ADOPTION_ACCOUNTS_FAILED";

export const FETCHING_TOTAL_NUMBER_OF_ACCOUNTS = "FETCHING_TOTAL_NUMBER_OF_ACCOUNTS";
export const FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_SUCCEEDED = "FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_SUCCEEDED";
export const FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_FAILED = "FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_FAILED";

export const FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE = "FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE";
export const FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_SUCCEEDED = "FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_SUCCEEDED";
export const FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_FAILED = "FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_FAILED";

export const FETCHING_NEW_ACCOUNTS = "FETCHING_NEW_ACCOUNTS";
export const FETCHING_NEW_ACCOUNTS_SUCCEEDED = "FETCHING_NEW_ACCOUNTS_SUCCEEDED";
export const FETCHING_NEW_ACCOUNTS_FAILED = "FETCHING_NEW_ACCOUNTS_FAILED";

export const FETCHING_CHURNED_ACCOUNTS = "FETCHING_CHURNED_ACCOUNTS";
export const FETCHING_CHURNED_ACCOUNTS_SUCCEEDED = "FETCHING_CHURNED_ACCOUNTS_SUCCEEDED";
export const FETCHING_CHURNED_ACCOUNTS_FAILED = "FETCHING_CHURNED_ACCOUNTS_FAILED";

// Fetching trail and suspended accounts
export const FETCHING_TRIAL_ACCOUNTS = "FETCHING_TRIAL_ACCOUNTS";
export const FETCHING_TRIAL_ACCOUNTS_SUCCEEDED = "FETCHING_TRIAL_ACCOUNTS_SUCCEEDED";
export const FETCHING_TRIAL_ACCOUNTS_FAILED = "FETCHING_TRIAL_ACCOUNTS_FAILED";

export const FETCHING_SUSPENDED_ACCOUNTS = "FETCHING_SUSPENDED_ACCOUNTS";
export const FETCHING_SUSPENDED_ACCOUNTS_SUCCEEDED = "FETCHING_SUSPENDED_ACCOUNTS_SUCCEEDED";
export const FETCHING_SUSPENDED_ACCOUNTS_FAILED = "FETCHING_SUSPENDED_ACCOUNTS_FAILED";

export const FETCHING_TERMINATED_ACCOUNTS = "FETCHING_TERMINATED_ACCOUNTS";
export const FETCHING_TERMINATED_ACCOUNTS_SUCCEEDED = "FETCHING_TERMINATED_ACCOUNTS_SUCCEEDED";
export const FETCHING_TERMINATED_ACCOUNTS_FAILED = "FETCHING_TERMINATED_ACCOUNTS_FAILED";

export const FETCHING_TOTAL_USERS = "FETCHING_TOTAL_USERS"; 
export const FETCHING_TOTAL_USERS_SUCCEEDED = "FETCHING_TOTAL_USERS_SUCCEEDED"; 
export const FETCHING_TOTAL_USERS_FAILED = "FETCHING_TOTAL_USERS_FAILED"; 

export const FETCHING_ACTIVE_USERS = "FETCHING_ACTIVE_USERS"; 
export const FETCHING_ACTIVE_USERS_SUCCEEDED = "FETCHING_ACTIVE_USERS_SUCCEEDED"; 
export const FETCHING_ACTIVE_USERS_FAILED = "FETCHING_ACTIVE_USERS_FAILED"; 

export const FETCHING_TOTAL_ASSETS = "FETCHING_TOTAL_ASSETS"; 
export const FETCHING_TOTAL_ASSETS_SUCCEEDED = "FETCHING_TOTAL_ASSETS_SUCCEEDED"; 
export const FETCHING_TOTAL_ASSETS_FAILED = "FETCHING_TOTAL_ASSETS_FAILED";

export const FETCHING_TOTAL_COLLECTIONS = "FETCHING_TOTAL_COLLECTIONS"; 
export const FETCHING_TOTAL_COLLECTIONS_SUCCEEDED = "FETCHING_TOTAL_COLLECTIONS_SUCCEEDED"; 
export const FETCHING_TOTAL_COLLECTIONS_FAILED = "FETCHING_TOTAL_COLLECTIONS_FAILED";

export const FETCHING_TOTAL_STREAMS = "FETCHING_TOTAL_STREAMS"; 
export const FETCHING_TOTAL_STREAMS_SUCCEEDED = "FETCHING_TOTAL_STREAMS_SUCCEEDED"; 
export const FETCHING_TOTAL_STREAMS_FAILED = "FETCHING_TOTAL_STREAMS_FAILED";

export const FETCHING_DAILY_ACTIVE_USERS = "FETCHING_DAILY_ACTIVE_USERS"; 
export const FETCHING_DAILY_ACTIVE_USERS_SUCCEEDED = "FETCHING_DAILY_ACTIVE_USERS_SUCCEEDED"; 
export const FETCHING_DAILY_ACTIVE_USERS_FAILED = "FETCHING_DAILY_ACTIVE_USERS_FAILED";

export const FETCHING_DAILY_ACTIVE_USERS_TIMELINE = "FETCHING_DAILY_ACTIVE_USERS_TIMELINE";
export const FETCHING_DAILY_ACTIVE_USERS_TIMELINE_SUCCEEDED = "FETCHING_DAILY_ACTIVE_USERS_TIMELINE_SUCCEEDED";
export const FETCHING_DAILY_ACTIVE_USERS_TIMELINE_FAILED = "FETCHING_DAILY_ACTIVE_USERS_TIMELINE_FAILED";

export const FETCHING_WEEKLY_ACTIVE_USERS = "FETCHING_WEEKLY_ACTIVE_USERS"; 
export const FETCHING_WEEKLY_ACTIVE_USERS_SUCCEEDED = "FETCHING_WEEKLY_ACTIVE_USERS_SUCCEEDED"; 
export const FETCHING_WEEKLY_ACTIVE_USERS_FAILED = "FETCHING_WEEKLY_ACTIVE_USERS_FAILED";

export const FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE = "FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE";
export const FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_SUCCEEDED = "FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_SUCCEEDED";
export const FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_FAILED = "FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_FAILED";

export const FETCHING_MONTHLY_ACTIVE_USERS = "FETCHING_MONTHLY_ACTIVE_USERS"; 
export const FETCHING_MONTHLY_ACTIVE_USERS_SUCCEEDED = "FETCHING_MONTHLY_ACTIVE_USERS_SUCCEEDED"; 
export const FETCHING_MONTHLY_ACTIVE_USERS_FAILED = "FETCHING_MONTHLY_ACTIVE_USERS_FAILED";

export const FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE = "FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE"; 
export const FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_SUCCEEDED = "FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_SUCCEEDED"; 
export const FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_FAILED = "FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_FAILED";

export const FETCHING_INTEGRATIONS = "FETCHING_INTEGRATIONS"; 
export const FETCHING_INTEGRATIONS_SUCCEEDED = "FETCHING_INTEGRATIONS_SUCCEEDED"; 
export const FETCHING_INTEGRATIONS_FAILED = "FETCHING_INTEGRATIONS_FAILED";

export const FETCHING_STREAM_CREATION = "FETCHING_STREAM_CREATION"; 
export const FETCHING_STREAM_CREATION_SUCCEEDED = "FETCHING_STREAM_CREATION_SUCCEEDED"; 
export const FETCHING_STREAM_CREATION_FAILED = "FETCHING_STREAM_CREATION_FAILED";

export const FETCHING_COLLECTION_CREATION = "FETCHING_COLLECTION_CREATION"; 
export const FETCHING_COLLECTION_CREATION_SUCCEEDED = "FETCHING_COLLECTION_CREATION_SUCCEEDED"; 
export const FETCHING_COLLECTION_CREATION_FAILED = "FETCHING_COLLECTION_CREATION_FAILED";

export const FETCHING_ASSET_CREATION = "FETCHING_ASSET_CREATION"; 
export const FETCHING_ASSET_CREATION_SUCCEEDED = "FETCHING_ASSET_CREATION_SUCCEEDED"; 
export const FETCHING_ASSET_CREATION_FAILED = "FETCHING_ASSET_CREATION_FAILED";

export const FETCHING_ASSET_VIEWING = "FETCHING_ASSET_VIEWING"; 
export const FETCHING_ASSET_VIEWING_SUCCEEDED = "FETCHING_ASSET_VIEWING_SUCCEEDED"; 
export const FETCHING_ASSET_VIEWING_FAILED = "FETCHING_ASSET_VIEWING_FAILED";

export const FETCHING_ASSET_SHARING = "FETCHING_ASSET_SHARING"; 
export const FETCHING_ASSET_SHARING_SUCCEEDED = "FETCHING_ASSET_SHARING_SUCCEEDED"; 
export const FETCHING_ASSET_SHARING_FAILED = "FETCHING_ASSET_SHARING_FAILED";

export const FETCHING_TOTAL_LEADS_REQUEST = "FETCHING_TOTAL_LEADS_REQUEST";
export const FETCHING_TOTAL_LEADS_SUCCEEDED = "FETCHING_TOTAL_LEADS_SUCCEEDED";
export const FETCHING_TOTAL_LEADS_FAILED = "FETCHING_TOTAL_LEADS_FAILED";

// fliteview - shares email open rate metrics
export const FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_REQUEST = "FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_REQUEST"; 
export const FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_SUCCEEDED = "FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_FAILED = "FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_FAILED";

// fliteview - shares link open rate metrics
export const FETCHING_FLITEVIEW_LINK_OPEN_RATE_REQUEST = "FETCHING_FLITEVIEW_LINK_OPEN_RATE_REQUEST"; 
export const FETCHING_FLITEVIEW_LINK_OPEN_RATE_SUCCEEDED = "FETCHING_FLITEVIEW_LINK_OPEN_RATE_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_LINK_OPEN_RATE_FAILED = "FETCHING_FLITEVIEW_LINK_OPEN_RATE_FAILED";

// fliteview - shares average time spent metrics
export const FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_REQUEST = "FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_REQUEST"; 
export const FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_SUCCEEDED = "FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_FAILED = "FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_FAILED";

// fliteview - personalised links
export const FETCHING_FLITEVIEW_PERSONALISED_LINKS_REQUEST = "FETCHING_FLITEVIEW_PERSONALISED_LINKS_REQUEST"; 
export const FETCHING_FLITEVIEW_PERSONALISED_LINKS_SUCCEEDED = "FETCHING_FLITEVIEW_PERSONALISED_LINKS_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_PERSONALISED_LINKS_FAILED = "FETCHING_FLITEVIEW_PERSONALISED_LINKS_FAILED";

// fliteview - anonymous links
export const FETCHING_FLITEVIEW_ANONYMOUS_LINKS_REQUEST = "FETCHING_FLITEVIEW_ANONYMOUS_LINKS_REQUEST"; 
export const FETCHING_FLITEVIEW_ANONYMOUS_LINKS_SUCCEEDED = "FETCHING_FLITEVIEW_ANONYMOUS_LINKS_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_ANONYMOUS_LINKS_FAILED = "FETCHING_FLITEVIEW_ANONYMOUS_LINKS_FAILED";


// fliteview - sessions count metrics
export const FETCHING_FLITEVIEW_SESSIONS_REQUEST = "FETCHING_FLITEVIEW_SESSIONS_REQUEST"; 
export const FETCHING_FLITEVIEW_SESSIONS_SUCCEEDED = "FETCHING_FLITEVIEW_SESSIONS_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_SESSIONS_FAILED = "FETCHING_FLITEVIEW_SESSIONS_FAILED";

// fliteview - personalised sessions count metrics
export const FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_REQUEST = "FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_REQUEST"; 
export const FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_SUCCEEDED = "FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_FAILED = "FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_FAILED";

// fliteview - anonymous sessions count metrics
export const FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_REQUEST = "FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_REQUEST"; 
export const FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_SUCCEEDED = "FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_FAILED = "FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_FAILED";

// fliteview - sessions unique visitors
export const FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_REQUEST = "FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_REQUEST"; 
export const FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_SUCCEEDED = "FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_FAILED = "FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_FAILED";

// fliteview - sessions completion metrics
export const FETCHING_FLITEVIEW_SESSIONS_COMPLETION_REQUEST = "FETCHING_FLITEVIEW_SESSIONS_COMPLETION_REQUEST"; 
export const FETCHING_FLITEVIEW_SESSIONS_COMPLETION_SUCCEEDED = "FETCHING_FLITEVIEW_SESSIONS_COMPLETION_SUCCEEDED"; 
export const FETCHING_FLITEVIEW_SESSIONS_COMPLETION_FAILED = "FETCHING_FLITEVIEW_SESSIONS_COMPLETION_FAILED";

// fetching weekly active users adoption matrix
export const FETCHING_WEEKLY_ADOPTION_MATRIX_REQUEST = "FETCHING_WEEKLY_ADOPTION_MATRIX_REQUEST"; 
export const FETCHING_WEEKLY_ADOPTION_MATRIX_SUCCEEDED = "FETCHING_WEEKLY_ADOPTION_MATRIX_SUCCEEDED"; 
export const FETCHING_WEEKLY_ADOPTION_MATRIX_FAILED = "FETCHING_WEEKLY_ADOPTION_MATRIX_FAILED";

// fetching weekly active users adoption matrix
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_REQUEST = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_REQUEST"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_SUCCEEDED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_SUCCEEDED"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_FAILED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_FAILED";

export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_REQUEST = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_REQUEST"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_SUCCEEDED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_SUCCEEDED"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_FAILED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_FAILED";

export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_REQUEST = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_REQUEST"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_SUCCEEDED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_SUCCEEDED"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_FAILED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_FAILED";

export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_REQUEST = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_REQUEST"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_SUCCEEDED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_SUCCEEDED"; 
export const FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_FAILED = "FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_FAILED";

// fetching weekly active users adoption matrix
export const FETCHING_WEEKLY_ADOPTION_LIST_REQUEST = "FETCHING_WEEKLY_ADOPTION_LIST_REQUEST"; 
export const FETCHING_WEEKLY_ADOPTION_LIST_SUCCEEDED = "FETCHING_WEEKLY_ADOPTION_LIST_SUCCEEDED"; 
export const FETCHING_WEEKLY_ADOPTION_LIST_FAILED = "FETCHING_WEEKLY_ADOPTION_LIST_FAILED";

// download data
export const DOWNLOAD_REQUEST = "DOWNLOAD_REQUEST";
export const DOWNLOAD_SUCCEEDED = "DOWNLOAD_SUCCEEDED";
export const DOWNLOAD_FAILED = "DOWNLOAD_FAILED";

// account basic details
export const UPDATING_BASIC_ACCOUNT  = "UPDATING_BASIC_ACCOUNT";
export const UPDATING_BASIC_ACCOUNT_SUCCEEDED = "UPDATING_BASIC_ACCOUNT_SUCCEEDED";
export const UPDATING_BASIC_ACCOUNT_FAILED = "UPDATING_BASIC_ACCOUNT_FAILED";

//fetching basic account details
export const FETCHING_BASIC_ACCOUNT_DETAILS = "FETCHING_BASIC_ACCOUNT_DETAILS";
export const FETCHING_BASIC_ACCOUNT_DETAILS_SUCCEEDED = "FETCHING_BASIC_ACCOUNT_DETAILS_SUCCEEDED";
export const FETCHING_BASIC_ACCOUNT_DETAILS_FAILED = "FETCHING_BASIC_ACCOUNT_DETAILS_FAILED";

//Getting Admin App Users:
export const FETCHING_ADMIN_APP_USERS = "FETCHING_ADMIN_APP_USERS";
export const FETCHING_ADMIN_APP_USERS_SUCCEEDED = "FETCHING_ADMIN_APP_USERS_SUCCEEDED";
export const FETCHING_ADMIN_APP_USERS_FAILED = "FETCHING_ADMIN_APP_USERS_FAILED";

//updating csm
export const UPDATING_CONTACT_DETAILS = "UPDATING_CONTACT_DETAILS";
export const UPDATING_CONTACT_DETAILS_SUCCEEDED = "UPDATING_CONTACT_DETAILS_SUCCEEDED";
export const UPDATING_CONTACT_DETAILS_FAILED = "UPDATING_CONTACT_DETAILS_FAILED";

//updating onboarding details
export const UPDATING_ONBOARDING_DETAILS = "UPDATING_ONBOARDING_DETAILS";
export const UPDATING_ONBOARDING_DETAILS_SUCCEEDED = "UPDATING_ONBOARDING_DETAILS_SUCCEEDED";
export const UPDATING_ONBOARDING_DETAILS_FAILED = "UPDATING_ONBOARDING_DETAILS_FAILED";

//DATASOURCE ACTIONS

export const FETCHING_DATASOURCE = "FETCHING_DATASOURCE";
export const FETCHING_DATASOURCE_SUCCEEDED = "FETCHING_DATASOURCE_SUCCEEDED";
export const FETCHING_DATASOURCE_FAILED = "FETCHING_DATASOURCE_FAILED";

export const FETCHING_DATASOURCE_MAPPINGS = "FETCHING_DATASOURCE_MAPPINGS";
export const FETCHING_DATASOURCE_MAPPINGS_SUCCEEDED = "FETCHING_DATASOURCE_MAPPINGS_SUCCEEDED";
export const FETCHING_DATASOURCE_MAPPINGS_FAILED = "FETCHING_DATASOURCE_MAPPINGS_FAILED";

export const FETCHING_DATASOURCE_CHILD_MAPPINGS = "FETCHING_DATASOURCE_CHILD_MAPPINGS";
export const FETCHING_DATASOURCE_CHILD_MAPPINGS_SUCCEEDED = "FETCHING_DATASOURCE_CHILD_MAPPINGS_SUCCEEDED";
export const FETCHING_DATASOURCE_CHILD_MAPPINGS_FAILED = "FETCHING_DATASOURCE_CHILD_MAPPINGS_FAILED";

export const FETCHING_DATASOURCE_TRANSACTIONS = "FETCHING_DATASOURCE_TRANSACTIONS";
export const FETCHING_DATASOURCE_TRANSACTIONS_SUCCEEDED = "FETCHING_DATASOURCE_TRANSACTIONS_SUCCEEDED";
export const FETCHING_DATASOURCE_TRANSACTIONS_FAILED = "FETCHING_DATASOURCE_TRANSACTIONS_FAILED";

export const TRIGGER_DATASOURCE_MAPPING_SYNC = "TRIGGER_DATASOURCE_MAPPING_SYNC";
export const TRIGGER_DATASOURCE_MAPPING_SYNC_SUCCEDDED = "TRIGGER_DATASOURCE_MAPPING_SYNC_SUCCEDDED";
export const TRIGGER_DATASOURCE_MAPPING_SYNC_FAILED = "TRIGGER_DATASOURCE_MAPPING_SYNC_FAILED";

//collection 
export const FETCHING_COLLECTIONS = "FETCHING_COLLECTIONS";
export const FETCHING_COLLECTIONS_SUCCEEDED = "FETCHING_COLLECTIONS_SUCCEEDED";
export const FETCHING_COLLECTIONS_FAILED = "FETCHING_COLLECTIONS_FAILED";

//Migrations

export const MIGRATING_COLLECTIONS = "MIGRATING_COLLECTIONS";
export const MIGRATINGCOLLECTIONS_SUCCEEDED = "MIGRATINGCOLLECTIONS_SUCCEEDED";
export const MIGRATINGCOLLECTIONS_FAILED = "MIGRATINGCOLLECTIONS_FAILED";
//orderform in basic details

//getting order forms

export const FETCHING_ORDER_FORMS = "FETCHING_ORDER_FORMS";
export const FETCHING_ORDER_FORMS_SUCCEEDED = "FETCHING_ORDER_FORMS_SUCCEEDED";
export const FETCHING_ORDER_FORMS_FAILED = "FETCHING_ORDER_FORMS_FAILED";

//uploading order form

export const UPLOADING_ORDER_FORM = "UPLOADING_ORDER_FORM"
export const UPLOADING_ORDER_FORM_SUCCEEDED = "UPLOADING_ORDER_FORM_SUCCEEDED"
export const UPLOADING_ORDER_FORM_FAILED = "UPLOADING_ORDER_FORM_FAILED"

// deleting order form

export const DELETING_ORDER_FORM = "DELETING_ORDER_FORM";
export const DELETING_ORDER_FORM_SUCCEEDED = "DELETING_ORDER_FORM_SUCCEEDED";
export const DELETING_ORDER_FORM_FAILED = "DELETING_ORDER_FORM_FAILED";

// invalidate order forms
export const INVALIDATE_ORDER_FORMS = "INVALIDATE_ORDER_FORMS";

export const DOWNLOADING_ORDER_FORM = "DOWNLOADING_ORDER_FORM"
export const DOWNLOADING_ORDER_FORM_SUCCEEDED = "DOWNLOADING_ORDER_FORM_SUCCEEDED"
export const DOWNLOADING_ORDER_FORM_FAILED = "DOWNLOADING_ORDER_FORM_FAILED"

//color palette

export const UPDATE_COLOR_PALETTE = "UPDATE_COLOR_PALETTE"
export const UPDATE_COLOR_SUCCEEDED = "UPDATE_COLOR_SUCCEEDED"
export const UPDATE_COLOR_FAILED = "UPDATE_COLOR_FAILED"

//seekLimit

export const SEEK_LIMIT = "SEEK_LIMIT";
export const SEEK_LIMIT_SUCCEEDED = "SEEK_LIMIT_SUCCEEDED";
export const SEEK_LIMIT_FAILED = "SEEK_LIMIT_FAILED";

//suggestions

export const UPDATE_SUGGESTIONS = "UPDATE_SUGGESTIONS";
export const UPDATE_SUGGESTIONS_SUCCEEDED = "UPDATE_SUGGESTIONS_SUCCEEDED";
export const UPDATE_SUGGESTIONS_FAILED = "UPDATE_SUGGESTIONS_FAILED";

//seeksuggestions

export const FETCHING_SUGGESTIONS ="FETCHING_SUGGESTIONS";
export const FETCHING_SUGGESTIONS_SUCCEEDED ="FETCHING_SUGGESTIONS_SUCCEEDED";
export const FETCHING_SUGGESTIONS_FAILED ="FETCHING_SUGGESTIONS_FAILED";

//inviting user

export const INVITING_USER_REQUEST = "INVITING_USER_REQUEST";
export const INVITING_USER_REQUEST_SUCCEEDED = "INVITING_USER_REQUEST_SUCCEEDED";
export const INVITING_USER_REQUEST_FAILED = "INVITING_USER_REQUEST_FAILED";

//fetching SSO

export const FETCHING_SSO_CONFIGURATION = "FETCHING_SSO_CONFIGURATION";
export const FETCHING_SSO_CONFIGURATION_SUCCEEDED = "FETCHING_SSO_CONFIGURATION_SUCCEEDED";
export const FETCHING_SSO_CONFIGURATION_FAILED = "FETCHING_SSO_CONFIGURATION_FAILED";


// change current Product
export const CHANGE_CURRENT_PRODUCT = "CHANGE_CURRENT_PRODUCT";

//update Contract term 

export const UPDATE_CONTRACT_TERM = "UPDATE_CONTRACT_TERM";
export const UPDATE_CONTRACT_TERM_SUCCEEDED = "UPDATE_CONTRACT_TERM_SUCCEEDED";
export const UPDATE_CONTRACT_TERM_FAILED = "UPDATE_CONTRACT_TERM_FAILED";


// fetch licence count

export const FETCHING_LICENCE_COUNT = "FETCHING_LICENCE_COUNT";
export const FETCHING_LICENCE_COUNT_SUCCEEDED="FETCHING_LICENCE_COUNT_SUCCEEDED";
export const FETCHING_LICENCE_COUNT_FAILED = "FETCHING_LICENCE_COUNT_FAILED";

export const UPDATE_LICENCE_COUNT = "UPDATE_LICENCE_COUNT";
export const UPDATE_LICENCE_COUNT_SUCCEEDED = "UPDATE_LICENCE_COUNT_SUCCEEDED";
export const UPDATE_LICENCE_COUNT_FAILED = "UPDATE_LICENCE_COUNT_FAILED";


// fetch subscription plan
export const FETCH_SUBSCRIPTION_PLAN = "FETCH_SUBSCRIPTION_PLAN";
export const FETCH_SUBSCRIPTION_PLAN_SUCCEEDED = "FETCH_SUBSCRIPTION_PLAN_SUCCEEDED";
export const FETCH_SUBSCRIPTION_PLAN_FAILED = "FETCH_SUBSCRIPTION_PLAN_FAILED";

// fetch available subscription plan 
export const FETCH_AVAILABLE_PLANS = "FETCH_AVAILABLE_PLANS";
export const FETCH_AVAILABLE_PLANS_SUCCEEDED = "FETCH_AVAILABLE_PLANS_SUCCEEDED";
export const FETCH_AVAILABLE_PLANS_FAILED = "FETCH_AVAILABLE_PLANS_FAILED";


// update plan type

export const UPDATING_SUBSCRIPTION_TYPE = "UPDATING_SUBSCRIPTION_TYPE";
export const UPDATING_SUBSCRIPTION_TYPE_SUCCEEDED = "UPDATING_SUBSCRIPTION_TYPE_SUCCEEDED";
export const UPDATING_SUBSCRIPTION_TYPE_FAILED = "UPDATING_SUBSCRIPTION_TYPE_FAILED";

// fetching customer details 

export const FETCHING_CUSTOMER_DETAILS = "FETCHING_CUSTOMER_DETAILS";
export const FETCHING_CUSTOMER_DETAILS_SUCCEEDED = "FETCHING_CUSTOMER_DETAILS_SUCCEEDED";
export const FETCHING_CUSTOMER_DETAILS_FAILED = "FETCHING_CUSTOMER_DETAILS_FAILED";

// updating customer details 

export const UPDATING_CUSTOMER_DETAILS = "UPDATING_CUSTOMER_DETAILS";
export const UPDATING_CUSTOMER_DETAILS_SUCCEEDED = "UPDATING_CUSTOMER_DETAILS_SUCCEEDED";
export const UPDATING_CUSTOMER_DETAILS_FAILED = "UPDATING_CUSTOMER_DETAILS_FAILED";


// fetching report generation details

export const FETCHING_GENERATED_REPORT = "FETCHING_GENERATED_REPORT";
export const FETCHING_GENERATED_REPORT_SUCCEEDED = "FETCHING_GENERATED_REPORT_SUCCEEDED";
export const FETCHING_GENERATED_REPORT_FAILED = "FETCHING_GENERATED_REPORT_FAILED";

export const GENERATING_REPORT_REQUEST = "GENERATING_REPORT_REQUEST";
export const GENERATING_REPORT_REQUEST_SUCCEEDED =
  "GENERATING_REPORT_REQUEST_SUCCEEDED";
export const GENERATING_REPORT_REQUEST_FAILED = "GENERATING_REPORT_REQUEST_FAILED";

export const UPLOAD_CUSTOM_FONT = "UPLOAD_CUSTOM_FONT";
export const UPLOADING_CUSTOM_FONT_SUCCEEDED =
  "UPLOADING_CUSTOM_FONT_SUCCEEDED";
export const UPLOADING_CUSTOM_FONT_FAILED = "UPLOADING_CUSTOM_FONT_FAILED";

/*fetch account integrations */
export const FETCHING_ACCOUNT_INTEGRATIONS = "FETCHING_ACCOUNT_INTEGRATIONS";
export const FETCHING_ACCOUNT_INTEGRATIONS_SUCCEEDED =
  "FETCHING_ACCOUNT_INTEGRATIONS_SUCCEEDED";
export const FETCHING_ACCOUNT_INTEGRATIONS_FAILED = "FETCHING_ACCOUNT_INTEGRATIONS_FAILED";
export const FETCHING_ACCOUNT_ASSETS = "FETCHING_ACCOUNT_ASSETS";
export const FETCHING_ACCOUNT_ASSETS_SUCCEEDED = "FETCHING_ACCOUNT_ASSETS_SUCCEEDED";
export const FETCHING_ACCOUNT_ASSETS_FAILED = "FETCHING_ACCOUNT_ASSETS_FAILED";

export const RE_TRIGGER_ASSET = "RE_TRIGGER_ASSET";
export const RE_TRIGGER_ASSET_SUCCEEDED = "RE_TRIGGER_ASSET_SUCCEEDED";
export const RE_TRIGGER_ASSET_FAILED = "RE_TRIGGER_ASSET_FAILED";
export const INVALID_REPROCESSING_ASSET = "INVALID_REPROCESSING_ASSET";

//fetch asset processing metrics
export const FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS = "FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS";
export const FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_SUCCEED = "FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_SUCCEED"
export const FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_FAILED = "FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_FAILED"

//fetch datasource mapping processing metrics
export const FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS = "FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS";
export const FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_SUCCEED = "FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_SUCCEED"
export const FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_FAILED = "FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_FAILED"

//fetch asset processing email template

export const FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE ="FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE";
export const FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_SUCCEEDED ="FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_SUCCEEDED";
export const FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_FAILED="FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_FAILED";

//fetch asset processing email trigger

export const FETCHING_ADMIN_USERS_FOR_ACCOUNT ="FETCHING_ADMIN_USERS_FOR_ACCOUNT";
export const FETCHING_ADMIN_USERS_FOR_ACCOUNT_SUCCEEDED ="FETCHING_ADMIN_USERS_FOR_ACCOUNT_SUCCEEDED";
export const FETCHING_ADMIN_USERS_FOR_ACCOUNT_FAILED="FETCHING_ADMIN_USERS_FOR_ACCOUNT_FAILED";